<template>
  <div v-if="currentMessage" id="toast-container" class="toast-top-right">
    <div class="toast" aria-live="polite" style :class="color">
      <div class="toast-progress" :style="{ width: progressPercent + '%' }" />

      <button
        type="button"
        aria-label="Zamknij notyfikację"
        class="toast-close-button"
        role="button"
        @click="hideNotification"
      >
        <i class="fas fa-times" />
      </button>

      <button
        v-if="paused"
        type="button"
        aria-label="Kontynuuj wyświetlanie notyfikacji"
        class="toast-close-button mr-2"
        role="button"
        @click="resumeNotification"
      >
        <i class="fas fa-play" />
      </button>

      <button
        v-else
        type="button"
        aria-label="Zapauzuj wyświetlanie notyfikacji"
        class="toast-close-button mr-2"
        role="button"
        @click="pauseNotification"
      >
        <i class="fas fa-pause" />
      </button>

      <div class="toast-message" role="alert">
        {{ title }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

// @vuese
// Notyfikacje
// @group AppLayout
export default {
  name: 'Notifications',
  props: {
    // Pozycja na osi X
    x: { type: String, default: null },
    // Pozycja na osi Y
    y: { type: String, default: 'top' },
    // Czas wyświetlania notyfikacji
    timeout: { type: Number, default: 6000 }
  },
  data() {
    return {
      timeoutId: undefined,
      intervalId: undefined,
      paused: false,
      timer: 0,
      timerIntervalTime: 10
    };
  },
  computed: {
    ...mapGetters(['currentMessage']),
    color() {
      const currentMessage = this.currentMessage;
      return currentMessage && currentMessage.color;
    },
    messageId() {
      const currentMessage = this.currentMessage;
      return currentMessage && currentMessage.id;
    },
    title() {
      const currentMessage = this.currentMessage;
      return currentMessage && currentMessage.message && currentMessage.message.title;
    },
    progressPercent() {
      const percent = ((this.timeout - this.timer) / this.timeout) * 100;
      return Math.round(percent * 100) / 100;
    }
  },
  watch: {
    messageId(newVal) {
      this.clearTimers();
      this.startNotification();
    }
  },
  methods: {
    // @vuese
    // Odświeża czas wyświetlania notyfikacji
    startNotification() {
      if (this.title) {
        this.paused = false;
        this.timeoutId = setTimeout(() => this.hideNotification(), this.timeout);
        this.intervalId = setInterval(() => this.incTimer(), this.timerIntervalTime);
      }
    },
    // @vuese
    // Zamyka notyfikacje
    hideNotification() {
      this.$store.dispatch('hideNotification');
    },
    // @vuese
    // Czyści czas wyświetlania notyfikacji
    clearTimers() {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }

      if (this.intervalId) {
        clearInterval(this.intervalId);
      }

      this.timer = 0;
    },
    // @vuese
    // Zwiększa timer
    incTimer() {
      this.timer += this.timerIntervalTime;
    },
    // @vuese
    // Pauzuje notyfikacje
    pauseNotification() {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        clearInterval(this.intervalId);
        this.paused = true;
      }
    },
    // @vuese
    // Kontynuuje wyświetlanie notyfikacji
    resumeNotification() {
      this.paused = false;
      this.timeoutId = setTimeout(() => this.hideNotification(), this.timeout - this.timer);
      this.intervalId = setInterval(() => this.incTimer(), this.timerIntervalTime);
    }
  }
};
</script>

<style>
.toast-close-button:focus {
  color: #ffffff;
  opacity: 0.8;
  -ms-filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=80);
  filter: alpha(opacity=80);
}
.toast-close-button:hover {
  color: #000000 !important;
  opacity: 0.4;
}
.toast-close-button {
  font-size: 0.875rem;
}
</style>
